const schemas = {
  EveryMatrix: (data) => ({
    // Credentials
    email: data.credentials.email,
    username: data.credentials.username,
    alias: data.credentials.alias,
    password: data.credentials.password,
    confirm: data.credentials.password,
    passwordRepeat: data.credentials.password,
    // User data
    birthDate: data.user.birthday && data.user.birthday.toISOString().split('T')[0],
    dob: data.user.birthday && data.user.birthday.toISOString().split('T')[0],
    gender: data.user.gender && data.user.gender.slice(0, 1).toUpperCase(),
    postalCode: data.user.postalCode,
    country: data.user.country,
    region: data.user.province,
    city: data.user.city,
    address1: data.user.houseNumber + ' ' + data.user.streetName,
    phone: data.user.phone,
    mobile: data.user.mobile,
    currency: data.user.currency,
    // GDPR
    acceptNewsEmail: (data.consent.offer_email && data.consent.offer_email.consent) || false,
    acceptSMSOffer: (data.consent.offer_sms && data.consent.offer_sms.consent) || false
  }),

  GIG: (data) => {
    const birthdate = data.user.birthdate
    return {
      // Credentials
      email: data.credentials.email,
      username: data.credentials.username,
      password: data.credentials.password,
      repeatPassword: data.credentials.password,
      // User data
      birth: birthdate && birthdate.toISOString().split('T')[0],
      ddlDay: birthdate && birthdate.getDate(),
      ddlMonth: birthdate && birthdate.getMonth() + 1,
      ddlYear: birthdate && birthdate.getFullYear(),
      title: data.user.title,
      firstname: data.user.firstName,
      surname: data.user.lastName,
      currency: data.user.currency,
      securityQuestion: data.user.securityQuestion,
      securityAnswer: data.user.securityAnswer,
      postalCode: data.user.postalCode,
      country: data.user.country,
      city: data.user.city,
      address1: data.user.houseNumber + ' ' + data.user.streetName,
      phone: data.user.phoneWithoutPrefix,
      phonePrefix: data.user.phonePrefix,
      mobile: data.user.phoneWithoutPrefix,
      mobilePrefix: data.user.phonePrefix,
      // GDPR
      consent_termsandconditions: data.consent.terms ? 'yes' : 'no',
      consent_emailmarketing: data.consent.offer_email ? 'yes' : 'no',
      consent_sms: data.consent.offer_sms ? 'yes' : 'no',
      consent_3rdparty: data.consent.thirdparty ? 'yes' : 'no',
      acceptTermsConditions: (data.consent.terms && data.consent.terms.consent) || false,
      allowNewsEmail: (data.consent.offer_email && data.consent.offer_email.consent) || false,
      allowSmsOffer: (data.consent.offer_sms && data.consent.offer_sms.consent) || false
    }
  },
  luckydays: (data) => {
    const birthdate = data.user.birthdate
    if(data.variant === 'verify') {
      return {
        birthdate: birthdate,
        firstName: data.user.firstName,
        lastName: data.user.lastName,
        fullName: data.user.fullName,
        citizenship: data.user.nationality || '',
        ocrData: data.ocrData || {},
      }
    }
    return {
      // Credentials
      email: data.credentials.email,
      password: data.credentials.password,
      // User data
      birthdate: birthdate,
      firstName: data.user.firstName,
      lastName: data.user.lastName,
      fullName: data.user.fullName,
      postalCode: data.user.postalCode,
      country: data.user.country,
      city: data.user.city,
      provinceCode: data.user.provinceCode || '',
      provinceName: data.user.provinceName || '',
      address: data.user.houseNumber + ' ' + data.user.streetName,
      phone: data.user.phone,
      mobilePrefix: data.user.phonePrefix,
      // GDPR
      consent: data.consent,
      // PEP check
      sanctions: data.sanction.flag && data.sanction.result ? data.sanction.result : [],
      idinSkipped: data.user.skipIdinValidation,
      ...(data.variant === 'canada' && {
        citizenship: data.user.nationality || 'CA',
        nationality: data.user.nationality || 'CA',
        employer: data.employer || {},
        job: data.job || {},
      }),
    }
  }
}

const transformData = (data, schema) => schemas[schema](data)

export default transformData



// WEBPACK FOOTER //
// ./src/utils/data-transfrom.js